import React, { createContext, useContext } from 'react';

const SubscriptionContext = createContext(null);

// VERSION ACCÈS LIBRE - Pas d'abonnement requis
// Retourne toujours un accès complet pour tous
export const SubscriptionProvider = ({ children }) => {
  // Accès libre: tout le monde a accès complet
  const value = {
    hasAccess: true,  // Toujours true
    isAdmin: false,   // Pas de concept d'admin en accès libre
    loading: false    // Pas de loading
  };

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export function useSubscription() {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within SubscriptionProvider');
  }
  return context;
}
